var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.l_visible
    ? _c(
        "div",
        {
          staticClass: "forma-podnikania-group",
          class: { readonly: _vm.readonly || _vm.getDisabled || _vm.isLoading }
        },
        [
          _c(
            "v-btn-toggle",
            {
              staticClass: "forma-podnikania-group-row row ma-0",
              class: {},
              attrs: {
                value: _vm.l_value,
                mandatory: _vm.mandatory,
                group: ""
              },
              on: { change: _vm.onChange }
            },
            [
              _vm._l(_vm.l_data, function(item, index) {
                return [
                  _c(
                    "v-btn",
                    {
                      key: index,
                      attrs: {
                        value: item.valueMember,
                        small: _vm.small,
                        disabled: _vm.getDisabled || _vm.isItemDisabled(item)
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "forma-podnikania-icon" },
                        [
                          _c("v-icon", [
                            _vm._v(_vm._s(_vm.getIcon(item.valueMember)))
                          ])
                        ],
                        1
                      ),
                      _c("div", { staticClass: "forma-podnikania-text" }, [
                        _c("span", [_vm._v(_vm._s(item.displayMember))])
                      ])
                    ]
                  )
                ]
              })
            ],
            2
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }